import * as React from 'react'
import { TechnicalOrder } from '@models/technical-orders'
import { useCreateOrUpdateTechnicalOrderMutation } from '@api/technical-orders'
import { useNotificationHook } from '@hyper/use-notification-hook'

export const useTechnicalOrderStart = ({ technicalOrders }: { technicalOrders: TechnicalOrder[] }) => {
  const [updateTechnicalOrder] = useCreateOrUpdateTechnicalOrderMutation()
  const { addSuccessNotification } = useNotificationHook()

  return React.useCallback(async () => {
    for (const technicalOrder of technicalOrders) {
      await updateTechnicalOrder({
        data: {},
        url: technicalOrder.urls.start,
      }).unwrap()
    }

    addSuccessNotification('Zadanie zostało rozpoczęte')
  }, [technicalOrders, updateTechnicalOrder])
}
